<template>
  <!-- Badge Harmonia+ : même langage « 3D » que le bouton soleil / IconTile,
       une ombre franche (épaisseur) dans la tranche premium, plus le reflet qui
       balaie la pilule (.plus-shine). Le texte reste AU-DESSUS du reflet, sinon
       le « H+ » disparaît un instant à chaque passage.

       Purement décoratif depuis que la modale « qu'est-ce qu'Harmonia+ » a
       disparu : le badge MARQUE une porte fermée, il ne l'ouvre pas. Ce qui
       l'ouvre, c'est l'élément sur lequel il est posé, qui mène au paywall.
       C'est d'ailleurs plus sûr : le badge est presque toujours à l'intérieur
       d'un bouton, et un bouton dans un bouton n'est ni du HTML valide ni
       cliquable de façon prévisible. -->
  <span
    data-testid="harmonia-plus-badge"
    class="plus-shine inline-flex justify-center items-center rounded-full bg-premium-soft px-2 py-0.5 text-[10px] font-bold tracking-wide text-premium"
    style="box-shadow: 0 2px 0 0 var(--color-premium-edge);"
  >
    <span class="relative z-[2]">H+</span>
  </span>
</template>
